import {
  AppSettingsModel,
  AppSettingsState,
  DataLookupState,
  DocumentsToStoreState,
  DocumentTypes,
  ArenaSignSignerRoleManagementState,
  ArenaSignTemplateManagementState,
  GroupedTableStateModel,
  StandardOrganisation,
  TableStateModel,
  UserManagementState,
  TableSortModel,
  TableFilterModel
} from '@/types';
import { ListMaintenanceState } from '@/types/store/ListMaintenanceState';
import { Dictionary } from 'vue-router/types/router';

export const appSettingsState = {
  appSettings: {} as AppSettingsModel
} as AppSettingsState;

export const getAppSettingsState = () => {
  return {
    appSettings: {} as AppSettingsModel
  } as AppSettingsState;
};

export const getUserManagementState = () => {
  return {
    organisationId: StandardOrganisation.InternalUsers,
    showDeactivated: false,
    isLoading: false,
    error: false,
    errorMessage: ''
  } as UserManagementState;
};

export const getOrganisationManagementState = () => {
  return {
    organisationId: StandardOrganisation.InternalUsers,
    showDeactivated: false,
    isLoading: false,
    error: false,
    errorMessage: ''
  } as UserManagementState;
};

export const getDocuSignTemplateManagementState = () => {
  return {
    tableState: {
      stateKey: '',
      showFilters: false,
      showSorting: false,
      currentPage: 1,
      itemsPerPage: 10,
      searchQuery: '',
      sortBy: '',
      sortDesc: false,
      selectedPk: '',
      filteredItems: []
    } as TableStateModel,
    documentTypeId: null
  } as ArenaSignTemplateManagementState;
};

export const getDocuSignSignerRoleManagementState = () => {
  return {
    tableState: {
      stateKey: '',
      showFilters: false,
      showSorting: false,
      currentPage: 1,
      itemsPerPage: 10,
      searchQuery: '',
      sortBy: '',
      sortDesc: false,
      selectedPk: '',
      filteredItems: []
    } as TableStateModel,
    documentTypeId: null
  } as ArenaSignSignerRoleManagementState;
};

export const getDocumentsToStoreState = () => {
  return {
    error: false,
    errorMessage: '',
    isLoading: false,
    selectedDocumentToStoreDocumentType: DocumentTypes.MyDocuments,
    documentsLookupState: DataLookupState.Loading
  } as DocumentsToStoreState;
};

export const getGroupedTableState = () => {
  return {
    lastExpandedGroups: {} as Dictionary<string[]>
  } as GroupedTableStateModel;
};

export const getArenaSignTemplateManagementState = () => {
  return {
    tableState: {
      stateKey: '',
      showFilters: false,
      showSorting: false,
      currentPage: 1,
      itemsPerPage: 10,
      searchQuery: '',
      sortBy: '',
      sortDesc: false,
      selectedPk: '',
      filteredItems: []
    } as TableStateModel,
    documentTypeId: null
  } as ArenaSignTemplateManagementState;
};

export const getArenaSignSignerRoleManagementState = () => {
  return {
    tableState: {
      stateKey: '',
      showFilters: false,
      showSorting: false,
      currentPage: 1,
      itemsPerPage: 10,
      searchQuery: '',
      sortBy: '',
      sortDesc: false,
      selectedPk: '',
      filteredItems: []
    } as TableStateModel,
    documentTypeId: null
  } as ArenaSignSignerRoleManagementState;
};

export const getListMaintenanceState = () => {
  return {
    tableState: {
      stateKey: '',
      showFilters: false,
      showSorting: false,
      currentPage: 1,
      itemsPerPage: 10,
      searchQuery: '',
      sortBy: '',
      sortDesc: false,
      selectedPk: '',
      filteredItems: []
    } as TableStateModel,
    filterOptions: [] as TableFilterModel[],
    sortOptions: [] as TableSortModel[]
  } as ListMaintenanceState;
};
